'use strict';

import { formatUsDate } from './studyBuilder.dateDisplay.js';
import { selectionsSummaryLines } from './studyBuilderSummaryLabels.js';

function linesBlock(lineItems) {
	if (!Array.isArray(lineItems) || lineItems.length === 0) return '  (none)';
	return lineItems
		.map((row, i) => {
			const bits = [`${i + 1}. Species: ${row.species || '—'}`];
			if (row.matrix) bits.push(`Organism: ${row.matrix}`);
			if (row.matrixCategory) bits.push(`Matrix: ${row.matrixCategory}`);
			if (row.matrixType) bits.push(`Matrix Type: ${row.matrixType}`);
			bits.push(`Samples: ${row.count ?? '0'}`);
			if (String(row.otherNotes || '').trim()) bits.push(`Notes: ${String(row.otherNotes).trim()}`);
			return `  ${bits.join(' · ')}`;
		})
		.join('\n');
}

/**
 * Plain-text body for study summary + indicative estimate (e.g. email to the submitter).
 * @param {{
 *   fitSelections: Record<string, unknown>,
 *   primaryProduct: { name?: string }|null,
 *   draft: { lineItems: Array, sampleInfo: Object, contactInfo: Object },
 *   totalSamples: number,
 *   estimatedCostDisplay: string|null,
 *   estimatedCompletionDisplay: string|null,
 *   quoteSampleBasisDisplay: string|null,
 * }} p
 */
export function buildStudyBuilderQuoteSummaryPlainText(p) {
	const { fitSelections, primaryProduct, draft, totalSamples, estimatedCostDisplay, estimatedCompletionDisplay, quoteSampleBasisDisplay } = p;
	const { lineItems, sampleInfo, contactInfo } = draft;
	const lines = selectionsSummaryLines(fitSelections, primaryProduct);
	const selectionText = lines.map(([k, v]) => `${k}: ${v ?? '—'}`).join('\n');

	const logistics = [
		`Number of samples (quote lines): ${totalSamples}`,
		...(quoteSampleBasisDisplay ? [`Quote sample basis: ${quoteSampleBasisDisplay}`] : []),
		`Sample volume: ${sampleInfo.sampleVolume ?? '—'}`,
		`Sample shipping: ${sampleInfo.sampleShipping ?? '—'}`,
		`Sample collection kit: ${sampleInfo.sampleKit === 'yes' ? 'Yes' : 'No'}`,
		`Planned shipping date: ${sampleInfo.plannedShippingDate ? formatUsDate(sampleInfo.plannedShippingDate) : '—'}`,
		`Estimated completion date: ${estimatedCompletionDisplay || '—'}`,
		`Estimated cost (indicative): ${estimatedCostDisplay || '—'}`,
	].join('\n');

	return [
		'Metabolon — Study builder (indicative estimate)',
		'',
		'CONTACT',
		`Name: ${contactInfo.firstName || ''} ${contactInfo.lastName || ''}`.trim() || '—',
		`Email: ${contactInfo.email || '—'}`,
		`Company: ${contactInfo.company || '—'}`,
		`Country: ${contactInfo.country || '—'}`,
		...(contactInfo.message ? [`Message: ${contactInfo.message}`] : []),
		'',
		'SELECTIONS',
		selectionText,
		'',
		'SAMPLE MATRIX LINES (QUOTE)',
		linesBlock(lineItems),
		'',
		'SAMPLE LOGISTICS & ESTIMATE',
		logistics,
		'',
		'This estimate is indicative only; final scope and pricing require confirmation with Metabolon.',
	].join('\n');
}
